<template>
  <div class="empty-section-bookmarks__content dea-bg-grey-light">
    <div class="grid grid--wide">
      <template v-if="parent">
        <div class="empty-section-bookmarks__content-title-parent xs-12 dea-heading--regular-xxl">
          Qui troverai tutti gli articoli di Dlive che aggiungerai ai preferiti.
        </div>
        <div class="xs-12 dea-heading--regular__m">
          Non perderti gli articoli di Dlive che pensi possano tornarti utili! Aggiungili ai preferiti mentre consulti
          il blog.
        </div>
        <div class="xs-12 empty-section-bookmarks__instruction">
          <div class="dea-heading--regular__m">
            Clicca (o, se stai usando uno smartphone o un tablet, tocca) l'icona della stella:
          </div>
          <div class="dea-ico-preferiti empty-section-bookmarks__icon"></div>
          <div class="dea-heading--regular__m">
            Diventerà scura
            <div class="dea-ico-preferiti empty-section-bookmarks__icon empty-section-bookmarks__icon--negative"></div>
            e l'articolo sarà disponibile qui.
          </div>
        </div>
        <div class="empty-section-bookmarks__content-goto-section xs-12">
          <div class="empty-section-bookmarks__content-goto-section--title dea-heading--medium-xl">
            Comincia a leggere!
          </div>
          <Buttons
            class="dea-button--large dea-button--iconRight dea-button--inline "
            href="https://blog.deascuola.it"
            icon="go-to"
            type="a"
            target="_blank"
          >
            Vai a Dlive
          </Buttons>
        </div>
      </template>
      <template v-else>
        <div class="xs-12 dea-heading--regular__m">
          Non perderti le risorse che pensi possano tornarti utili! Aggiungile ai preferiti mentre consulti uno dei
          <router-link class="dea-links  dea-links--pointer" :class="`dea-links--${linkColor}`" :to="{ name: 'books' }">
            <span class="dea-links__label dea-heading--regular__m">tuoi libri</span></router-link
          >
          o utilizzi un portale o uno strumento Deascuola!
        </div>
        <div class="xs-12 empty-section-bookmarks__instruction">
          <div class="dea-heading--regular__m">
            Clicca (o, se stai usando uno smartphone o un tablet, tocca) l'icona della stella:
          </div>
          <div class="dea-ico-preferiti empty-section-bookmarks__icon"></div>
          <div class="dea-heading--regular__m">
            Diventerà scura
            <div class="dea-ico-preferiti empty-section-bookmarks__icon empty-section-bookmarks__icon--negative"></div>
            e il tuo contenuto sarà disponibile qui in Area Personale.
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Buttons from "deascuola-storybook/src/components/elements/Buttons";

export default {
  name: "EmptyBookmarks",
  components: { Buttons },
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    parent: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_empty-section"; //sass-lint:disable-line clean-import-paths

.empty-section-bookmarks {
  @include empty-section;
  @include empty-section-bookmarks;

  &__content-title-parent {
    margin-bottom: $space-xx-large;
  }

  &__content-goto-section {
    margin-top: $space-x-large;

    &--title {
      margin-bottom: $space-xm-small;
    }
  }
}
</style>
